export const AGENT_LIST_ACTION = "AGENT_LIST_ACTION";
export const AGENT_ALL_LIST_ACTION = "AGENT_ALL_LIST_ACTION";
export const AGENT_LIST_SUCCESS = "AGENT_LIST_SUCCESS";
export const AGENT_LIST_FAIL = "AGENT_LIST_SUCCESS";

export const AGENT_DETAIL_ACTION = "AGENT_DETAIL_ACTION";
export const AGENT_DETAIL_SUCCESS = "AGENT_DETAIL_SUCCESS";

export const AGENT_DETAIL_CREATE_ACTION = "AGENT_DETAIL_CREATE_ACTION";
export const AGENT_DETAIL_UPDATE_ACTION = "AGENT_DETAIL_UPDATE_ACTION";
export const AGENT_DETAIL_DELETE_ACTION = "AGENT_DETAIL_DELETE_ACTION";
export const AGENT_DETAIL_FAIL = "AGENT_DETAIL_FAIL";

export const AGENT_LIST_REPORTS_ACTION = "AGENT_LIST_REPORTS_ACTION";
export const AGENT_LIST_REPORTS_SUCCESS = "AGENT_LIST_REPORTS_SUCCESS";